import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

import ServiceIcon from '@components/Icons/ServiceIcon'
import SquareIconWithBackground from '@components/SquareIconWithBackground'

import type { OrderItemModel, ServiceModel } from '@models/types'
import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface HeaderProps {
  callbacks: {
    manageOrderItem: UseOrderItemPayload['callbacks']['manageOrderItem'],
  },
  orderItem: OrderItemModel,
  service: ServiceModel,
}

const Header = (props: HeaderProps) => {
  const {
    callbacks: {
      manageOrderItem,
    },
    orderItem: {
      title,
      options_string,
    },
    service,
  } = props

  return (
    <Box flexDirection={['column', 'row']} padding="large">
      <Box width="auto">
        <Box
          alignItems="center"
          backgroundColor="backgroundColor"
          borderRadius={5}
          height={44}
          justifyContent="center"
          width={44}
        >
          <SquareIconWithBackground backgroundColor="backgroundColor">
            <ServiceIcon
              fillColor="#8c8c8e"
              height={28}
              // @ts-expect-error TS2322
              serviceKey={service.short_name}
              width={28}
            />
          </SquareIconWithBackground>
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large" width="auto">
          <Text fontSize="medium">{title}</Text>
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            {options_string || 'No Options'}
          </Text>
        </Box>
      </Box>

      <Box alignItems="center" marginLeft="auto" marginTop={['large', 0]} width={['100%', 'auto']}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPencil} />}
          onClick={() => manageOrderItem()}
          size="medium"
          // @ts-expect-error
          width={['100%', 'auto']}
        >
          Manage Item
        </Button>
      </Box>
    </Box>
  )
}

export default Header
